/**
 * Inbox item types — unified to-dos that come to the service coordinator.
 * Used by Work Tasks dashboard and Test tools.
 */
export const INBOX_TYPE_OPTIONS = [
  { value: 'client_assignment', label: 'Client assignment' },
  { value: 'file_review', label: 'File review' },
  { value: 'at_packet', label: 'AT packet' },
  { value: 'monthly_contact', label: 'Monthly contact' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'assignment', label: 'Assignment' },
  { value: 'central_availability_ip', label: 'Central availability (in-person)' },
  { value: 'staff_notice', label: 'Staff notice' },
  { value: 'cs_need', label: 'Service need' },
  { value: 'cs_need_delay', label: 'Service delay' },
  { value: 'cs_need_change', label: 'Service change' },
  { value: 'eies_sped', label: 'EIES / SPED (tracking)' },
  { value: 'support_case', label: 'Support case' },
];

/**
 * @param {string|null|undefined} type - type code from API
 * @returns {string} display label
 */
export function getInboxTypeLabel(type) {
  if (!type) return 'Assignment';
  const opt = INBOX_TYPE_OPTIONS.find((o) => o.value === type);
  return opt ? opt.label : type;
}
